import { commonUtils } from '@/helpers/commonUtils'

import { userService } from '@/services/userService'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Popover } from 'antd'
import classNames from 'classnames'

import style from './ProHeader.module.less'

import { uiController } from '@/controllers/uiController'
import { routerService } from '@/services/routerService'
import { observer } from 'mobx-react'

import { UserInfoPopover } from '@/components/UserInfoPopover/UserInfoPopover'
import { VideoItem } from '@/components/VideoItem/VideoItem'
import { adService } from '@/services/adService'

/** Header 组件的 Props */
export type HeaderProps = {
  renderPage: 'normal' | 'success' | 'middle'
  exportToHtml: () => void
  exportToPdf: () => void
  shareHashId?: string
  onLogout?: () => void
  onLogin?: () => void
  onJoinClick: () => void
  onTabClick: (
    tab:
      | 'online'
      | 'img'
      | 'pdf'
      | 'pdfPro'
      | 'translate'
      | 'guide'
      | 'select'
      | 'learn'
      | 'word'
      | 'pdfUltra'
  ) => void
}

/**
 * @author TODO
 * (在这里对组件进行说明)
 */
export const ProHeader = observer((props: HeaderProps) => {
  const { onLogout, onLogin, onJoinClick, renderPage, onTabClick, exportToHtml, exportToPdf } =
    props

  const tabContent = () => {
    return (
      <>
        <div className={classNames(style.tab)} onClick={() => onTabClick('translate')}>
          <p className={classNames(style.text)}>网页翻译</p>
        </div>
        <div className={classNames(style.tab)} onClick={() => onTabClick('guide')}>
          <p className={classNames(style.text)}>功能指导</p>
        </div>
        <div className={classNames(style.tab)} onClick={() => onTabClick('select')}>
          <p className={classNames(style.text)}>悬停/划词翻译</p>
        </div>
        <div className={classNames(style.tab)} onClick={() => onTabClick('learn')}>
          <p className={classNames(style.text)}>学习模式</p>
        </div>
      </>
    )
  }

  const handleNewUser = () => {
    adService.addBingUetqToHead('signup', {})
  }

  return (
    <div
      className={classNames(style.header, 'proHeader', {
        [style.transparent]: renderPage === 'normal' || renderPage === 'middle',
      })}
    >
      <div className={style.left}>
        <img
          onClick={() => {
            routerService.navigateTo('dashboard')
          }}
          className={style.logo}
          src={commonUtils.getStaticFile('icon__logo.png')}
        />
        {/* tab区域 */}
        <>
          <div className={classNames(style.tabWrap)} style={{ marginLeft: '30px' }}>
            {/* 在线翻译 */}
            {/* <div className={classNames(style.tab)} onClick={() => onTabClick('online')}>
              <p className={classNames(style.text)}>在线翻译</p>
            </div> */}
            {/* 图片翻译 */}
            <div className={classNames(style.tab)} onClick={() => onTabClick('img')}>
              <p className={classNames(style.text)}>图片翻译</p>
            </div>

            {/* pdf_pro */}
            <div
              className={classNames(style.tab, { [style.pdfActive]: true })}
              onClick={() => onTabClick('pdfPro')}
            >
              <p className={classNames(style.text, { [style.active]: true })}>PDF分段翻译</p>
              <div className={classNames(style.line)}></div>
            </div>

            {/* pdf_ultra */}
            {
              <div className={classNames(style.tab)} onClick={() => onTabClick('pdfUltra')}>
                <p className={classNames(style.text)}>PDF无损翻译</p>
              </div>
            }

            <div className={classNames(style.tab)} onClick={() => onTabClick('word')}>
              <p className={classNames(style.text)}>Word翻译</p>
            </div>
          </div>
        </>
      </div>

      <div className={style.right}>
        {renderPage === 'success' && (
          <div
            className={style.linkBtn}
            onClick={() => {
              exportToHtml()
            }}
          >
            导出为HTML
          </div>
        )}

        {renderPage === 'success' && (
          <div
            className={style.linkBtn}
            onClick={() => {
              exportToPdf()
            }}
          >
            导出为PDF
            <Popover
              content={
                <VideoItem
                  src='https://cdn.yiban.io/web/pt-web/pdf-pro-guide-1.mp4'
                  autoPlay
                  className={classNames(style.video)}
                ></VideoItem>
              }
              placement={'bottom'}
              getPopupContainer={(el) => el.parentElement!}
            >
              <QuestionCircleOutlined className={style.questionIcon} />
            </Popover>
          </div>
        )}
        {renderPage === 'success' && (
          <div
            className={style.linkBtn}
            onClick={() => {
              routerService.openNewTab('pdf_pro')
            }}
          >
            上传
          </div>
        )}

        <div className={style.linkBtn}>
          <Popover
            getPopupContainer={(el) => el.parentElement!}
            content={
              <>
                <img className={classNames(style.staff)} src={userService.staffQrUrl} />
              </>
            }
          >
            联系我们
          </Popover>
        </div>

        <div
          className={style.linkBtn}
          onClick={() => {
            routerService.openNewTab('pricing')
          }}
        >
          定价
        </div>
        {userService.initialed && !userService.isLogin && (
          <>
            <div
              className={style.linkBtn}
              onClick={() => {
                if (onLogin) {
                  onLogin()
                  return
                }
                uiController.loginModalProps = { open: true, giftUserProPlus: 1, handleNewUser }
              }}
            >
              登录
            </div>
            <div
              className={style.register}
              onClick={() => {
                if (onLogin) {
                  onLogin()
                  return
                }
                uiController.loginModalProps = { open: true, giftUserProPlus: 1, handleNewUser }
              }}
            >
              免费注册
            </div>
          </>
        )}
        {userService.isLogin && (
          <>
            <div
              className={classNames(style.dashboardBtn)}
              onClick={() => {
                routerService.openNewTab('dashboard')
              }}
            >
              翻译工具箱
            </div>
            <UserInfoPopover
              trigger='hover'
              displayType='popover'
              placement='bottom'
              getPopupContainer={(el) => el.parentElement!}
            >
              <div className={style.avatar}>
                <img
                  className={style.userAvatar}
                  src={userService.userData!.wxAvatar || commonUtils.getDefaultAvatar()}
                />
                <img className={style.rect} src={commonUtils.getStaticFile('pdf/rect.png')} />
              </div>
            </UserInfoPopover>
          </>
        )}
      </div>
    </div>
  )
})
